<template>
    <!-- <div class="container" style="width: 100vw; height: 100vh;">
    <div class="card" style="padding: 30px;height: 90vh;margin-top: -30px;overflow-y: scroll;"> -->
    <div class="container" style="width: 100vw; height: 100vh;">
    <span class="text-danger fs-3 fw-bold">LTC Red Army</span>
    <!-- <span class="text-black-50 fs-3 fw-bold"> Duties 2023</span> -->
    <div class="row justify-content-center" style="padding-top: 30px;">
      <div class="col-md-6">
        <span class="text-center"><b>Enter OTP</b></span> <br>
        <a href="javascript:void(0)" @click="clickResendOtp();">(I wasn't getting an OTP)</a>
          
          <table style="width:100%">
            <tr>
              <td style="width:25%"></td>
              <td style="width:10%">
                <div style="text-align: center;width:28px;height: 45px;border: 1px solid grey;border-radius: 4px;padding:10px;">
                <span>{{ num1 }}</span>
                </div>
              </td>
              <td style="width:10%">
                <div style="text-align: center;width:28px;height: 45px;border: 1px solid grey;border-radius: 4px;padding:10px;">
                <span>{{ num2 }}</span>
                </div>
              </td>
              <td style="width:10%">
                <div style="text-align: center;width:28px;height: 45px;border: 1px solid grey;border-radius: 4px;padding:10px;">
                <span>{{ num3 }}</span>
                </div>
              </td>
              <td style="width:10%">
                <div style="text-align: center;width:28px;height: 45px;border: 1px solid grey;border-radius: 4px;padding:10px;">
                <span>{{ num4 }}</span>
                </div>
              </td>
              <td style="width:10%">
                <div style="text-align: center;width:28px;height: 45px;border: 1px solid grey;border-radius: 4px;padding:10px;">
                <span>{{ num5 }}</span>
                </div>
              </td>
              <td style="width:25%"></td>
              </tr>
            </table>
          
          <br>
          
          <div class="otp-keypad">
            <div class="row" v-for="(row, rowIndex) in keypad" :key="rowIndex">
              <div
                class="col-4"
                v-for="(number, colIndex) in row"
                :key="`col-${colIndex}`"
              >
                <button
                  v-if="number !== null&&number !== -1"
                  class="btn btn-light btn-block mb-3 otp-keypad-button"
                  @click="onClickKeyPad(number)"
                >
                  {{ number }}
                </button>
                <button
                  v-else-if="number === -1"
                  class="btn btn-light btn-block mb-3 otp-keypad-button"
                  @click="onClickRemoveOtp()"
                >
                <!-- <i class="fa-solid fa-xmark"></i> -->
                <i class="fas fa-xmark" :style="{ 'color': 'red' }"></i>

                </button>
                <div v-else class="otp-keypad-empty-space"></div>
              </div>
            </div>
          </div>

          
      <!-- </div>
      </div> -->
      </div>

    </div>

    <!-- </div>
    </div> -->


    <!-- <div class="row">
          <div class="col-12 text-center">
            <button style="width:100%" type="submit" class="btn btn-primary" @click="verifyOtp()">Verify OTP</button>
          </div>
    </div> -->
  </div>
</template>

<script>
import axios from 'axios';
import Global from './GlobalVariable';
import Service from './Service';

export default {
  name: 'OtpPage',
  mixins: [Service],
  props: {
    msg: String
  },
  data() {
    return {
      keypad: [
        [1, 2, 3],
        [4, 5, 6],
        [7, 8, 9],
        [null, 0, -1],
      ],
      num1:null,
      num2:null,
      num3:null,
      num4:null,
      num5:null,
      // num6:null,
      otp:""                          
    };
  },
  methods: {
   verifyOtp: async function(){
    var vm = this;
      vm.showLoading();
      return await axios.post(Global.backendPath+"account/verifyOTP", {
        "username":localStorage.getItem("username"),
        "otp":vm.otp,"userId":localStorage.getItem("userId")
    },
      {
            headers: {
            "Authorization": localStorage.getItem("token")
            }
      })
      // Global.userIdentify = 14749
      //Global.userName = VT4584
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"&&response.data.result){
          Global.userObj = response.data.result;
          localStorage.setItem("userId",response.data.result.id)
          localStorage.setItem("userObj",JSON.stringify(response.data.result));
          
          // Global.token = response.data.token_object.token;
          // localStorage.setItem("token",response.data.token_object.token);
          vm.$router.push("/home");
        }else{
          var errorMsg = "";
          // Your confirm OTP is invalided : Otp ไม่ถูกต้อง
          // Your confirm OTP is already used : otp ถูกใข้งานแล้ว
          // Please confirm OTP before 3 minutes : OTP expire
          if(response.data.errorMsg){
            errorMsg = response.data.errorMsg;
          }else{
            errorMsg = 'Invalid OTP!';
          }
          vm.$swal.fire({
            icon: 'error',
            title: 'Warning!',
            text: errorMsg,
          });
          vm.num1=null;
          vm.num2=null;
          vm.num3=null;
          vm.num4=null;
          vm.num5=null;
          // vm.num6=null;
          vm.otp=""; 

        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
      });
   
   },
   onClickKeyPad: function(number){
    var vm = this;
    vm.otp += number;
    vm["num"+vm.otp.length] = number;
    if(vm.otp.length==5){
      vm.verifyOtp();
    }
   },
   onClickRemoveOtp: function(){
    var vm = this;
    vm["num"+vm.otp.length] = null;
    vm.otp=vm.otp.substring(0,vm.otp.length-1);
     

   },
   clickResendOtp: function(){
    var vm = this;
    vm.$swal.fire({
        title: 'Are you be sure to request OTP again?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Yes',
        denyButtonText: `No`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          vm.$router.push("/");
        } 
      });
   }
  },
};
</script>

<style scoped>
.otp-keypad {
  max-width: 50%;
  margin: 0 auto;
}

.otp-keypad-button {
  font-size: 1.5rem;
  font-weight: bold;
  border-radius: 50%;
  height: 60px;
  width: 60px;
  line-height: 60px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  background-color: #f1f1f1;
  border: none;
  outline: none;
  color: #333;
}

.otp-keypad-empty-space {
  height: 60px;
  width: 60px;
  background-color: transparent;
}


</style>
